import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './router/Router';
import GlobalProvider from 'src/context/GlobalProvider';
import NotificationsProvider from './context/NotificationsProvider';
import SQAConversationProvider from './context/SQAConversationProvider';
import AuthProvider from './providers/AuthProvider';
import ThemeProvider from './providers/ThemeProvider';
import GlobalWsClient from './components/WebSocket/GlobalWsClient';
import MasterAdminProvider from './context/MasterAdminProvider';
import SecurityAdvisorProvider from 'src/context/SecurityAdvisorProvider';
import DataSubjectRequestsProvider from 'src/context/DataSubjectRequestsProvider';
import AIModelsProvider from 'src/context/AIModelsProvider';
import AuditViewerProvider from './context/AuditViewerProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GlobalProvider>
    <ThemeProvider>
      <AuthProvider>
        <NotificationsProvider>
          <SQAConversationProvider>
            <MasterAdminProvider>
              <AIModelsProvider>
                <SecurityAdvisorProvider>
                  <DataSubjectRequestsProvider>
                    <AuditViewerProvider>
                      <Router />
                      <GlobalWsClient />
                    </AuditViewerProvider>
                  </DataSubjectRequestsProvider>
                </SecurityAdvisorProvider>
              </AIModelsProvider>
            </MasterAdminProvider>
          </SQAConversationProvider>
        </NotificationsProvider>
      </AuthProvider>
    </ThemeProvider>
  </GlobalProvider>
);
